import React from "react";
import { CHART_IDS } from "../../../../../config/featureConfig";
import TopClickedProductsChart from "../components/charts/TopClickedProductsChart";
import TopSearchedCategories from "../components/charts/TopSearchedCategories";

export function renderDashboardChart(chartDef, chartIndex, { embedInGrid = false, onOpenChartTab } = {}) {
  if (chartDef.id === CHART_IDS.TOP_PRODUCTS_BY_CLICK) {
    return (
      <TopClickedProductsChart
        embedInGrid={embedInGrid}
        onOpenInTabView={embedInGrid ? () => onOpenChartTab(chartIndex) : undefined}
      />
    );
  }

  if (chartDef.id === CHART_IDS.TOP_CATEGORIES_BY_SEARCH) {
    return (
      <TopSearchedCategories
        embedInGrid={embedInGrid}
        onOpenInTabView={embedInGrid ? () => onOpenChartTab(chartIndex) : undefined}
      />
    );
  }

  const ChartComponent = chartDef.Component;
  return <ChartComponent expandedView={!embedInGrid} />;
}
